import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiXCircle, FiMail, FiLogOut } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import styles from './AccountRejectedPage.module.css';

const AccountRejectedPage: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/auth/login');
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.iconContainer}>
            <FiXCircle className={styles.icon} />
          </div>
          <h1 className={styles.title}>Solicitud Rechazada</h1>
          <p className={styles.subtitle}>
            Lamentamos informarte que tu solicitud no ha sido aprobada
          </p>
        </div>

        <div className={styles.content}>
          <div className={styles.infoSection}>
            <h3 className={styles.sectionTitle}>
              <FiMail /> ¿Qué pasó?
            </h3>
            <p className={styles.infoText}>
              Después de revisar tu solicitud y documentos, nuestro equipo determinó que no cumples
              con algunos de los requisitos necesarios para abrir una cuenta en nuestra plataforma.
            </p>
          </div>

          <div className={styles.reasonsSection}>
            <h3 className={styles.sectionTitle}>Posibles razones:</h3>
            <ul className={styles.reasonsList}>
              <li>Información personal incompleta o inconsistente</li>
              <li>Documentos de identificación no válidos o ilegibles</li>
              <li>No cumplir con los requisitos de edad mínima</li>
              <li>Información que no coincide con registros oficiales</li>
              <li>Políticas internas de la empresa</li>
            </ul>
          </div>

          <div className={styles.nextStepsSection}>
            <h3 className={styles.sectionTitle}>¿Qué puedes hacer?</h3>
            <div className={styles.stepsList}>
              <div className={styles.step}>
                <span className={styles.stepNumber}>1</span>
                <div className={styles.stepContent}>
                  <h4>Contacta a soporte</h4>
                  <p>
                    Comunícate con nuestro equipo de soporte en{' '}
                    <a href="mailto:soporte@profunding.com">soporte@profunding.com</a> para
                    obtener más detalles sobre los motivos específicos del rechazo.
                  </p>
                </div>
              </div>

              <div className={styles.step}>
                <span className={styles.stepNumber}>2</span>
                <div className={styles.stepContent}>
                  <h4>Revisa tu información</h4>
                  <p>
                    Verifica que toda la información proporcionada sea correcta y que tus
                    documentos estén actualizados y sean legibles.
                  </p>
                </div>
              </div>

              <div className={styles.step}>
                <span className={styles.stepNumber}>3</span>
                <div className={styles.stepContent}>
                  <h4>Solicita nuevamente</h4>
                  <p>
                    Una vez que hayas corregido la información o actualizado tus documentos,
                    puedes crear una nueva cuenta y volver a solicitar el acceso.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.contactSection}>
            <h3 className={styles.sectionTitle}>Contacto</h3>
            <p className={styles.contactText}>
              Si tienes preguntas sobre esta decisión o necesitas asistencia, no dudes en
              contactarnos:
            </p>
            <div className={styles.contactInfo}>
              <p><strong>Email:</strong> <a href="mailto:soporte@profunding.com">soporte@profunding.com</a></p>
              <p><strong>Horario:</strong> Lunes a Viernes, 9:00 AM - 6:00 PM</p>
            </div>
          </div>
        </div>

        <div className={styles.actions}>
          <button onClick={handleLogout} className={styles.logoutButton}>
            <FiLogOut />
            Cerrar Sesión
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountRejectedPage;